import React from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/Showcase.css';

function Showcase() {

    const location = useLocation();

    const isFormSuccessPage = location.pathname === '/formsuccess';
    const isMenuPage = location.pathname === '/menu';
    const isContactPage = location.pathname === '/kontakt';
    const isAboutPage = location.pathname === '/o-nas';
    const isGalleryPage = location.pathname === '/galeria';
    const isPolicyPage = location.pathname === '/polityka';
    const isHomePage = location.pathname === '/';


    if (isHomePage || isAboutPage || isGalleryPage || isPolicyPage || isContactPage || isMenuPage) {
        return (
            <div className='container-fluid showcase text-white py-4 bg-green-light'>
                <ul className='container list list-unstyled'>
                    <li>
                    KUCHNIA POLSKA
                    </li>
                    <li>
                    IMPREZY OKOLICZNOŚCIOWE
                    </li>
                    <li>
                    DANCINGI
                    </li>
                </ul>
            </div>
        )
    } else {
        return null;
    }

}  

export default Showcase;